import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import styled from '@emotion/styled';
import Confirmation from '../confirmation';
import ReactTooltip from 'react-tooltip';
import { AppUI } from '@seedlang/state';
import Fa from 'components/fa';
import FaBlock from 'components/fa_block';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  margin: ${props => props.margin};
  width: fit-content;
  .delete-button-wrapper {
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    > * {
      cursor: inherit;
    }
  }
`;

@observer
class DeleteButton extends React.Component {
  @observable showConfirmation = false;

  constructor() {
    super();
    this.id = Math.random();
  }

  static defaultProps = {
    right: '40px',
    left: 'auto',
    top: '-30px',
    faIcon: 'fa-times',
  };

  onConfirm = () => {
    this.showConfirmation = false;
    if ((AppUI.user.currentUserGroup?.canDeleteRecords || this.props.allowDeletion) && this.props.onConfirm) {
      this.props.onConfirm();
    }
  }

  onTriggerClick = (event) => {
    event.stopPropagation();
    this.showConfirmation = true;
  }

  render() {
    return (
      <Wrapper
        className='delete-button-outer-wrapper'
        margin={this.props.margin}
        data-tip
        data-for={`confirmation-tooltip-${this.id}`}
        disabled={this.props.disabled}
      >
        {
          this.showConfirmation &&
            <Confirmation
              left={this.props.left}
              right={this.props.right}
              top={this.props.top}
              floatsRight={this.props.confirmationMessageFloatsRight}
              close={() => this.showConfirmation = false}
              onConfirm={this.onConfirm}
              showCloseButton={!AppUI.user.currentUserGroup?.canDeleteRecords && !this.props.allowDeletion}
              message={AppUI.user.currentUserGroup?.canDeleteRecords || this.props.allowDeletion ? this.props.message : '⚠ You don\'t have deletion rights.'}
            />
        }
        {
          this.props.children &&
            <div
              onClick={this.props.disabled ? null : this.onTriggerClick}
              className='delete-button-wrapper'
            >
              {this.props.children}
            </div>
        }
        {
          !this.props.children &&
            (
              this.props.className?.split(' ').includes('fa-block') ?
                <FaBlock
                  i={this.props.faIcon.replace(/^fa-/, '')}
                  onClick={this.props.disabled ? null : this.onTriggerClick}
                  className={this.props.className}
                  style={{color: this.props.iconColor, opacity: this.props.disabled ? '0.6' : '1'}}
                />
              :
                <Fa
                  i={this.props.faIcon.replace(/^fa-/, '')}
                  onClick={this.props.disabled ? null : this.onTriggerClick}
                  className={this.props.className}
                  style={{color: this.props.iconColor, opacity: this.props.disabled ? '0.6' : '1'}}
                />
            )
        }
        {
          this.props.message && this.props.showTooltip &&
            <ReactTooltip
              place={this.props.tooltipPosition || 'left'}
              type='dark'
              effect='solid'
              id={`confirmation-tooltip-${this.id}`}
              class='custom-tooltip'
            >
              {this.props.message}
            </ReactTooltip>
        }
      </Wrapper>
    );
  }
}

export default DeleteButton;
